import React, { useEffect, useState } from 'react';

/**
 * Boolean checkbox cell.
 *
 * Toggles optimistically via local state so the tick flips on the same click
 * instead of waiting on the parent's recalc round-trip.
 *
 * cellRendererParams (merged with column.cellProps):
 *   onRowChange(rowId, field, value)
 *   getRowId(row) -> string
 *   disabled
 */
function CheckboxCell(params) {
  const { value, data, colDef, onRowChange, getRowId, disabled } = params;
  const rowId = getRowId ? getRowId(data) : data?.id;
  const field = colDef?.field;

  const [checked, setChecked] = useState(Boolean(value));

  useEffect(() => {
    setChecked(Boolean(value));
  }, [value]);

  const handleChange = (e) => {
    setChecked(e.target.checked);
    onRowChange?.(rowId, field, e.target.checked);
  };

  return (
    <label className="cag-checkbox">
      <input type="checkbox" className="cag-checkbox-input" checked={checked} disabled={disabled} onChange={handleChange} />
    </label>
  );
}

export default CheckboxCell;
